import { useSelector } from 'react-redux'

import { selectStoreList } from '../../store/slices/storeListSlice'
import { selectCategoryList } from '../../store/slices/categoryListSlice'
import { selectSaleItemList } from '../../store/slices/saleItemListSlice'
import { formatSaleItemName } from '../../common/utils/functions/formatSaleItemName'


export const usePromoItemScreen = () => {
  const storeList = useSelector(selectStoreList)
  const categoryList = useSelector(selectCategoryList)
  const saleItemList = useSelector(selectSaleItemList)



  const getCategoryName = (id: number) => {
    return categoryList.find((el) => el.id === id)?.name
  }
  const getStoreName = (id: number) => {
    return storeList.find((el) => el.id === id)?.name
  }

  const getSaleItemName = (id: number): string => {
    const current = saleItemList.find((el) => el.id === id)

    if (!current) {
      return `Товар #${id}` // или ''
    }

    return formatSaleItemName(current, 2)
  }

  

  return { getCategoryName, getStoreName, getSaleItemName }
}
